import { useLocation, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Login() {
  const location = useLocation();
  const error = location.state?.error;

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#0A2E2C] px-6" data-testid="login-page">
      <div className="absolute inset-0" style={{ background: "radial-gradient(70% 70% at 50% 30%, rgba(11,59,60,0.6), transparent 70%)" }} />
      <div className="relative z-10 w-full max-w-md rounded-3xl border border-[#AEE6D5]/15 bg-[#0B3B3C]/70 p-10 text-center shadow-2xl backdrop-blur-xl">
        <p className="font-serif text-2xl italic text-[#AEE6D5]">Casey&#39;s Cadence</p>
        <h1 className="mt-5 font-serif text-3xl font-light text-[#F8FAFC]">Admin Access</h1>
        <p className="mt-3 text-sm leading-relaxed text-[#F8FAFC]/70">
          Sign in to view and export your booking inquiries. Access is restricted to authorized accounts.
        </p>

        {error === "unauthorized" && (
          <p className="mt-6 rounded-xl border border-red-400/40 bg-red-500/10 px-4 py-3 text-sm text-red-200" data-testid="login-error">
            This Google account isn&#39;t authorized for the dashboard.
          </p>
        )}
        {error && error !== "unauthorized" && (
          <p className="mt-6 rounded-xl border border-red-400/40 bg-red-500/10 px-4 py-3 text-sm text-red-200" data-testid="login-error">
            Sign-in didn&#39;t complete — please try again.
          </p>
        )}

        <button
          onClick={signIn}
          data-testid="login-google-btn"
          className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-8 py-4 text-sm font-bold text-[#0A2E2C] transition-all hover:scale-[1.02] hover:bg-[#B99628]"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#0A2E2C" d="M21.35 11.1H12v3.8h5.35c-.23 1.5-1.65 4.4-5.35 4.4-3.22 0-5.85-2.67-5.85-5.95S8.78 7.4 12 7.4c1.83 0 3.06.78 3.76 1.45l2.56-2.47C16.68 4.82 14.56 4 12 4 6.98 4 2.9 8.07 2.9 13.1S6.98 22.2 12 22.2c6.08 0 8.9-4.27 8.9-7.9 0-.53-.06-.93-.15-1.2Z" />
          </svg>
          Sign in with Google
        </button>

        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.18em] text-[#AEE6D5]/70 transition-colors hover:text-[#AEE6D5]" data-testid="login-back-link">
          <ArrowLeft className="h-3.5 w-3.5" /> Back to site
        </Link>
      </div>
    </div>
  );
}
